<template>
  <div class="main-chapter1">
    <n-loader :loading="$var('load')" />
    <div class="chapter-title">
      Записи
    </div>
    <n-link style="margin: 10px 0; float: right;" :to="createRecordLink"><n-button>Создать запись</n-button></n-link>
    <n-table :columns="columns" :data="data">
      <template #publishedAt="{item}">
        {{ $app.date.format(item.publishedAt) }}
      </template>
      <template #tools="{item}">
        <n-link :to="{query: { modal: 'record', id: item.id, projectId: project.id, journal: $route.params.journal, type: 'records', }}"><n-button icon="eye" /></n-link>
      </template>
    </n-table>
  </div>
</template>

<script>
export default {
  name: 'MainChapter4',
  props: [ 'project', 'journal', ],
  data: () => ({
    data: [],
  }),
  computed: {
    columns() {
      if (!this.journal?.front) {
        return []
      } else {
        return [
          ...this.journal.front.index[2].content,
          { name: 'tools', title: '', },
        ]
      }
    },
    createRecordLink() {
      return { query: { ...this.$route.query, 'new-record': null, }, }
    },
  },
  watch: {
    project() {
      this.load()
    },
  },
  mounted() {
    this.load()
  },
  methods: {
    load() {
      this.$var('load', true)
      $api.journalsOld.records.get(this.project.id, this.$route.params.journal, 'records').then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .main-chapter1 {
    &::v-deep {
      .n-table .row.header .cell {
        min-width: 100px;
      }
    }
  }
</style>
